export const Roles = {
  USER: 'user',
  ADMIN: 'admin',
  ROOT: 'root',
};
